// Campus photo for /colleges/city-college-of-new-york: CC BY 3.0, by Su & Soe, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AShepard_Hall.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/city-college-of-new-york/; credited under the photo.
const photo = {
    "slug": "city-college-of-new-york",
    "alt": "Shepard Hall, the dark stone and white terracotta Gothic building at City College of New York, with snow on the lawn",
    "src": "/colleges/city-college-of-new-york/campus-1600.webp",
    "srcSmall": "/colleges/city-college-of-new-york/campus-800.webp",
    "srcMid": "/colleges/city-college-of-new-york/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/city-college-of-new-york/og.jpg",
    "title": "Shepard Hall",
    "author": "Su & Soe",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AShepard_Hall.JPG",
    "read": "2026-10-01"
};

export default photo;
